import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  customer: null,
  subscriptionDetail: {},
  paymentDetails: {},
  membership: {},
  applicationData: {},
  isSessionBooked: false,
  isDiscounted: false,
}

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setCustomer: (state, action) => {
      state.customer = action.payload;
    },
    setSubscriptionDetail: (state, action) => {
      state.subscriptionDetail = action.payload;
    },
    setPaymentDetails: (state, action) => {
      state.paymentDetails = action.payload;
    },
    setApplicationData: (state, action) => {
      state.applicationData = action.payload;
    },
    setIsSessionBooked: (state, action) => {
      state.isSessionBooked = action.payload;
    },
    setMembership: (state, action) => {
      state.membership = action.payload;
    },
    setIsDiscounted: (state, action) => {
      state.isDiscounted = action.payload;
    }
  }
});

export const customer = (state) => state.customer.customer;
export const subscriptionDetail = (state) => state.customer.subscriptionDetail; // subscription api
export const paymentDetails = (state) => state.customer.paymentDetails; // payment details api
export const isSessionBooked = (state) => state.customer.isSessionBooked; // sesssion book api
export const customerId = (state) => state.customer.customer?.id;
export const customerName = (state) => state.customer.customer?.first_name;
export const isMember = (state) => state.customer.customer?.member;
export const isHealthSeeker = (state) => state.customer.customer?.health_seeker;
export const selectIsApproved = (state) => state.customer.customer?.approved;
export const membership = (state) => state.customer.membership; // membership api 
export const SelectApplicationData = (state) => state.customer.applicationData; // application api 
export const selectIsDiscounted = (state) => state.customer.isDiscounted; // discounted api 

export const {setCustomer, setSubscriptionDetail, setPaymentDetails, setIsSessionBooked, setMembership, setApplicationData, setIsDiscounted} = customerSlice.actions;

export default customerSlice.reducer;